function getMonthStr(date) {
  const month = date.getMonth() + 1;

  return month < 10 ? `0${month}` : month;
}

function getDayStr(date) {
  const day = date.getDate();

  return day < 10 ? `0${day}` : day;
}

export function createDataLookup(data) {
  const dates = data.map((d) => +d.date).sort();

  if (dates.length === 0) {
    return null;
  }

  const today = new Date('2020-09-16T00:00:00Z');
  const yesterday = new Date(today.valueOf() - 86400000 * 1);
  const eightDaysAgo = new Date(today.valueOf() - 86400000 * 8);
  const yesterdayStr = `${yesterday.getFullYear()}${getMonthStr(yesterday)}${getDayStr(yesterday)}`; // dates[0].toString();
  const eightDaysAgoStr = `${eightDaysAgo.getFullYear()}${getMonthStr(eightDaysAgo)}${getDayStr(eightDaysAgo)}`; //  dates[dates.length - 1].toString();
  const baStr = `20200621`; 
  const bbStr = `20200615`; 

  return data.reduce((res, item) => {
    if (typeof res[item.ags] === 'undefined') {
      const yesterdayData = data.find((d) => d.ags === item.ags && d.date === yesterdayStr);
      const eightDaysAgoData = data.find((d) => d.ags === item.ags && d.date === eightDaysAgoStr);
      const baData = data.find((d) => d.ags === item.ags && d.date === baStr);
      const bbData = data.find((d) => d.ags === item.ags && d.date === bbStr);

      const abs = yesterdayData.confirmed - eightDaysAgoData.confirmed;
      const rel = (abs / +item.population) * 100000;
      const absb = baData.confirmed - bbData.confirmed;
      const relb = (absb / +item.population) * 100000; 

      res[item.ags] = {
        rel: rel < 0 ? 0 : rel,
        abs: abs < 0 ? 0 : abs,
        absb: absb < 0 ? 0 : absb,
        relb: relb < 0 ? 0 : relb,
        pop: +item.population,
      };
    }
    return res;
  }, {});
}
